/**
 * Cart Vehicle Compatibility Badges
 * Shows per-item compatibility status on the cart page and cart drawer
 * based on the selected vehicle in sessionStorage.
 */

(function() {
  'use strict';

  function getSelectedVehicle() {
    return sessionStorage.getItem('selectedVehicle');
  }

  var applyingBadges = false;

  function applyBadges() {
    if (applyingBadges) return;
    applyingBadges = true;

    var selectedVehicle = getSelectedVehicle();
    if (!selectedVehicle) { applyingBadges = false; return; }

    var cartItems = document.querySelectorAll('.cart__item[data-cart-item-vehicles]');

    cartItems.forEach(function(item) {
      var badge = item.querySelector('[data-vehicle-badge]');
      if (!badge) return;

      var vehiclesStr = item.getAttribute('data-cart-item-vehicles') || '';

      if (!vehiclesStr.trim()) {
        badge.className = 'cart__vehicle-badge cart__vehicle-badge--universal';
        badge.textContent = 'Universal - fits most vehicles';
        badge.style.display = 'inline-block';
        return;
      }

      var vehicles = vehiclesStr.split('|').map(function(v) { return v.trim(); });
      var isCompatible = vehicles.indexOf(selectedVehicle) !== -1;

      if (isCompatible) {
        badge.className = 'cart__vehicle-badge cart__vehicle-badge--fits';
        badge.textContent = 'Fits your ' + selectedVehicle;
        badge.style.display = 'inline-block';
      } else {
        badge.className = 'cart__vehicle-badge cart__vehicle-badge--no-fit';
        badge.textContent = 'May not fit your ' + selectedVehicle;
        badge.style.display = 'inline-block';
      }
    });

    applyingBadges = false;
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBadges);
  } else {
    applyBadges();
  }

  // Re-run when AJAX cart drawer opens/updates
  document.addEventListener('cart:updated', applyBadges);
  document.addEventListener('ajaxCart:afterItemAdded', applyBadges);

})();
